import useTranslation from '@hooks/useTranslation'
import { ListItemText, Typography } from '@mui/material'
import { camelCase, deburr } from 'lodash'
import { FC } from 'react'

interface ListItemProps {
  name: string
  showTimeShortUTC?: boolean
}

const ListItem: FC<ListItemProps> = ({ name, showTimeShortUTC = false }) => {
  const { t, currentLanguage } = useTranslation()

  return (
    <ListItemText>
      <Typography
        sx={{
          fontSize: '14px',
          color: 'text.main',
          fontWeight: '400',
          lineHeight: '100%',
          padding: '10px 2px',
          ...(showTimeShortUTC && {
            width: '250px',
            overflowX: 'hidden',
          }),
        }}
      >
        {currentLanguage === 'en' ? t(camelCase(deburr(name + ''))) : name}
      </Typography>
    </ListItemText>
  )
}

export default ListItem
